module.exports = __webpack_public_path__ + "img/list-ol-solid.a9e79322.svg";